// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f8fc1847","83":"b61fded1","212":"8ff09a62","237":"413c798c","579":"c4ea76c3","715":"7029410c","804":"d5a3eef7","812":"b48ab591","822":"78679920"}[chunkId] + ".chunk.js";
};